import { Component, OnInit, inject } from '@angular/core';
import { SuggestionEngineService } from '../../../suggestion-engine/suggestion-engine.service';
import { Router } from '@angular/router';
import { DateTime } from 'luxon';
import { Callback, Followup } from '../../../models/suggestion-engine-models';

@Component({
  selector: 'app-follow-up',
  templateUrl: './followUp.component.html',
  styleUrls: ['./followUp.component.scss'],
  standalone: false,
})
export class FollowUpComponent implements OnInit {
  private ses = inject(SuggestionEngineService);
  private router = inject(Router);

  callbackList;
  followupList;
  callListNumber;
  state = 'loaded';

  ngOnInit() {
    this.ses.getFollowUp().subscribe((x: Followup) => {
      this.followupList = x.data.map(z => {
        return {
          id: z.id,
          name: z.FullName,
          suggestion: z.bridgename,
          detail: z.detailname + ' ' + z.detail,
        };
      });
    });

    this.ses.getCallList().subscribe((x: { data: any[] }) => {
      this.callListNumber = x.data.length;
    });

    this.ses.getCallback().subscribe((x: Callback) => {
      this.callbackList = x.data.map(z => {
        return {
          id: z.id,
          name: z.FullName,
          score: z.callbackScore,
          type: z.onType,
          date: z.itemDate,
        };
      });
    });
  }

  callListSearch() {
    this.router.navigate(['/se/search', { type: 'callList' }]);
  }

  callBackSearch() {
    this.router.navigate([
      '/se/search',
      {
        type: 'callBack',
        id: `${DateTime.now()
          .minus({ days: 7 })
          .toLocaleString()}~${DateTime.now().toLocaleString()}`,
      },
    ]);
  }

  goToProfile(ev, id) {
    this.router.navigate([`/se/client/${id}`]);
  }
}
